import React, {useMemo} from 'react';

import {
	CommandBarButtonCompat as CommandBarButton,
	IButtonStyles,
	IIconProps,
	TooltipHostCompat as TooltipHost,
} from 'components/FluentUICompat';

import {VexCluster} from 'types';

import {useLocation, useParams} from 'react-router-dom';

import {useTranslation} from 'react-i18next';

import {
	excelButtonLocation,
	excelButtonDisable,
	tooltipXL,
} from './ExcelExportCommon.react';

import {handleClickRegulationVersionDetailPage} from './XLRegulationVersionDetailPage';
import {handleClickRegulationDetailPage} from './XLRegulationDetailPage';
import {handleClickRequirementDetailPage} from './XLRequirementDetailPage';
import {handleClickAdminPage} from './XLAdminPage';
import {handleClickVkoVexPage} from './XLVkoVexPage';
import {IArrayRoles} from 'components/InfinityList/Excel/ExcelExportCommon';
import {handleClickBaslineCompare} from './XLBaselineCompare';
import {EntityListColumn} from '../EntityList';

interface ExcelButtonProps {
	entityListItems: any[];
	arrRoles: IArrayRoles;
	myVexClusters: VexCluster[];
	columns: EntityListColumn[];
	pageDetails: any | undefined;
}

export const ExcelExportButton: React.FC<ExcelButtonProps> = props => {
	const {t} = useTranslation();

	const location = useLocation();

	const {
		regulationId,
		regulatoryDocumentId,
		paragraphId,
		requirementId,
		modelSeries,
		generation,
		baselineId,
		id,
	} = useParams();

	const styles: IButtonStyles = useMemo(() => {
		return {root: {height: '100%'}};
	}, []);

	const iconProps: IIconProps = useMemo(() => {
		return {iconName: 'ExcelLogo'};
	}, []);

	const strLocationType: string = useMemo(
		() =>
			excelButtonLocation(location.pathname, {
				regulationId,
				regulatoryDocumentId,
				paragraphId,
				requirementId,
				modelSeries,
				generation,
				baselineId,
				id,
			}),
		[location],
	);

	const boolExcelButtonDisable = useMemo(() => {
		return excelButtonDisable(
			props.entityListItems.length,
			props.arrRoles,
			props.myVexClusters,
			strLocationType,
			props.pageDetails,
		);
	}, [location, props]);

	const getTooltipContent = (): string | undefined => {
		return tooltipXL(strLocationType, t);
	};

	let handleClick;

	if (props.entityListItems) {
		switch (strLocationType) {
			case 'regulation_detail_page':
				handleClick = async () =>
					handleClickRegulationDetailPage(
						props.entityListItems,
						props.pageDetails,
						props.columns,
						t,
					);
				break;

			case 'regulation_version_detail_page':
				handleClick = async () =>
					handleClickRegulationVersionDetailPage(
						props.entityListItems,
						props.arrRoles,
						props.pageDetails,

						t,
					);
				break;

			case 'requirements_detail_page':
				handleClick = async () =>
					handleClickRequirementDetailPage(
						props.entityListItems,
						props.arrRoles,
						props.pageDetails,
						t,
					);
				break;

			case 'vko_vex_page':
				handleClick = async () =>
					handleClickVkoVexPage(props.entityListItems, t);
				break;
			case 'admin_page':
				handleClick = async () =>
					handleClickAdminPage(
						props.entityListItems as any[],
						location.pathname.split('/')[2],
						t,
					);
				break;

			case 'baseline_compare_page':
				handleClick = async () =>
					handleClickBaslineCompare(
						props.entityListItems,
						props.arrRoles,
						props.pageDetails,
						props.columns,
						t,
					);
				break;

			default:
				handleClick = () => {
					console.log('page not found');
				};
		}
	}

	const buttonLabel = t('ExcelExport', {
		ns: 'components/EntityList/ExcelExport',
	});

	return (
		<TooltipHost content={getTooltipContent() ?? buttonLabel}>
			<CommandBarButton
				text={undefined}
				title={buttonLabel}
				ariaLabel={buttonLabel}
				styles={styles}
				iconProps={iconProps}
				onClick={handleClick}
				disabled={boolExcelButtonDisable}
			/>
		</TooltipHost>
	);
};
